import { colors } from "@indeed/ifl-tokens";
import { Platform, StyleSheet, type TextStyle } from "react-native";

export const styles = StyleSheet.create({
  defaultContainer: {
    gap: 16,
  },
  compactContainer: {
    gap: 12,
  },
  updatedWrapper: {
    width: "100%",
    gap: 16,
  },
  payInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: colors.neutral[700],
    borderStyle: "solid",
  },
  payInputWrapperInvalid: {
    borderColor: colors.alert[800],
  },
  // Web only: draw the focus ring on the whole field (currency + input + clear button) rather than
  // letting the inner input own it, so focus wraps the entire control instead of just the middle.
  payInputWrapperFocused:
    Platform.OS === "web"
      ? {
          outlineWidth: 2,
          outlineStyle: "solid",
          outlineColor: colors.foreground.primary["[base]"],
          outlineOffset: 2,
        }
      : {},
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- `outlineStyle: "none"` is valid on React Native Web but absent from RN core's style types (matches mads TextInput)
  payInput: {
    flexGrow: 1,
    margin: 0,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: "400",
    letterSpacing: 0,
    lineHeight: 24,
    color: colors.neutral[1000],
    paddingTop: Platform.OS === "ios" ? 0 : 9,
    paddingRight: 12,
    paddingBottom: 9,
    paddingLeft: 4,
    minHeight: 44,
    minWidth: 0,
    borderWidth: 0,
    // Web only: remove the browser's default per-input focus ring so the wrapper's ring is the sole
    // focus indicator (otherwise a second ring shows around just the input). `outlineWidth: 0` is
    // not enough — Chrome's focus uses `outline-style: auto`, so the style itself must be cleared.
    outlineStyle: Platform.OS === "web" ? "none" : undefined,
  } as unknown as TextStyle,
  payInputCurrency: {
    minWidth: 24,
    color: colors.neutral[700],
    justifyContent: "center",
    paddingLeft: 8,
    marginRight: 4,
    textAlign: "center",
    fontSize: 16,
  },
  payInputClearButton: {
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 12,
    alignSelf: "stretch",
  },
});
